// extracted by mini-css-extract-plugin
export default {"title":"kqEyLYq8h0mhPry5cws9"};